import React, { useEffect, useState } from 'react';
import ShareButton from '../components/ShareButton';
import { SubjectCards } from '../components/NotesParts';
import SubjectPicker from '../components/SubjectPicker';

// Page Notes : la liste des sujets. Un clic sur un sujet ouvre ses dissertations (NotesSubject).
export default function Notes() {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch('/api/notes/subjects')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(setSubjects)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  const total = subjects.reduce((n, s) => n + s.count, 0);
  return (
    <section className="section fade-in">
      <div className="section-head">
        <h2>notes</h2>
        <span className="head-right">
          <span className="counter">{String(subjects.length).padStart(2, '0')} sujet{subjects.length > 1 ? 's' : ''}</span>
          <ShareButton variant="icon" title="Notes — Zahra's Learning" text="Des notes et dissertations rangées par sujet" />
        </span>
      </div>
      {loading ? <div className="empty-state">chargement...</div> :
       error ? <div className="empty-state">impossible de charger les notes pour le moment — réessayez dans un instant.</div> :
       subjects.length === 0 ? <div className="empty-state">rien encore ici ✎</div> : (
        <>
          <p className="qcm-intro-line">Choisissez un sujet pour voir ses dissertations ({total} au total).</p>
          <SubjectPicker subjects={subjects} allHref="/notes" hrefFor={id => `/notes/sujet/${id}`} unit="diss." />
          <SubjectCards subjects={subjects} base="/notes" />
        </>
      )}
    </section>
  );
}
